import { render, staticRenderFns } from "./HOME.vue?vue&type=template&id=3cb2977c&scoped=true&"
import script from "./HOME.vue?vue&type=script&lang=js&"
export * from "./HOME.vue?vue&type=script&lang=js&"
import style0 from "./HOME.vue?vue&type=style&index=0&id=3cb2977c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2977c",
  null
  
)

export default component.exports